import { isDev, normalize, hideLoader, toLocale, hashString, inIframe, clone } from 'global/js/apps.js'
import Feedback from 'global/components/Feedback'
import Tabs from 'global/components/Tabs'
import Linechart from 'global/components/Linechart'
import Heatmap from 'global/components/Heatmap'
import Copyrights from 'global/components/Copyrights'
import Toggles from '../components/Toggles'
import PresiCandidate from 'global/components/PresiCandidate'
import Byline from '../components/Byline'
import PollsList from '../components/PollsList'
import nspPollsLogo from '../assets/nsp_polls.png' 

const chartDataUrls = {
	firstRound: {
		candidates: 'https://apps.contexte.com/data/ctx-presi-polls/chart_candidates.json',
		families: 'https://apps.contexte.com/data/ctx-presi-polls/chart_families.json',
	},
	runoffs: {
		candidates: 'https://apps.contexte.com/data/ctx-presi-polls/chart_runoff.json',
	},
	previous: {
		candidates: 'https://apps.contexte.com/data/ctx-presi-polls-2017/chart_candidates.json',
	}
}
const nspPollsUrl = 'https://github.com/nsppolls/nsppolls'
const pollCommitteeUrl = 'https://www.commission-des-sondages.fr/notices/'
const localRegressionUrl = 'https://fr.wikipedia.org/wiki/R%C3%A9gression_locale'
const contexteStoryUrl = 'https://www.contexte.com/article/pouvoirs/agregateur-de-sondages-de-la-presidentielle-2022_128913.html'
const orgShots = {
    'Harris Interactive' : 'HI',
    'Redfield & Wilton Strategies': 'R&W',
    'Opinion Way': 'Op. Way',
}

require('iframe-resizer/js/iframeResizer.contentWindow.min.js')

export default {
	name: 'Polls',
	components: { Feedback, Linechart, Copyrights, Toggles, PollsList, PresiCandidate, Tabs, Byline, Heatmap },
	data: function() {
		return {
			isDev: isDev(),
			mode: 'full',
			minHeight: 0,
			mobile: false,
			smallScreen: false,
			largeScreen: false,
			ready: false,
			innerWidth: window.innerWidth,
			pollsChart: '',
			defaultCandidatesNb: 5,
			minCandidateScore: 1.5,
			chartSettings: {
				desktop: null,
				mobile: null,
			},
			heatmapSettings: {},
			nspPolls: {
				logo: nspPollsLogo,
				url: nspPollsUrl,
				name: 'NSPPolls',
			},
			contexte: {
				urls: {
					story: 	contexteStoryUrl,
				}
			},
			pollCommittee: {
				url: pollCommitteeUrl,
				name: 'la Commission des sondages'
			},
			method: {
				urls : {
					localRegression: localRegressionUrl
				}
			},
			breakpoints: {
				mobile: 600,
				smallScreen: 900,
				largeScreen: 1200,
			},
			raw: {
				infos: {
					candidates: [],
					events: [],
					candidates2017: [],
				},
				chart: [],
				chartRunoffs: [],
				chartFamilies:[],
				chart2017: [],
			},
			urls: {
				infos: this.store.dzServerEditorial + this.store.dzPath.replace('/','-') + '.json',
				chartFirstRound: chartDataUrls.firstRound,
				chartRunoffs: chartDataUrls.runoffs.candidates,
				chart2017: chartDataUrls.previous.candidates,
			},
			rwdChartSettings: {
				mobile: {
					candidates: {
						margin: { top: 80, right: 162, bottom: 40, left: 75, },
						size: {	width: 800,	height: 1000, },
						lineWidth: 5,
						dotSize: 3,
					},
					families: {
						margin: { top: 80, right: 162, bottom: 40, left: 75, },
						size: {	width: 800,	height: 1000, },
						lineWidth: 5,
						dotSize: 3,						
					},
					previous: {
						margin: { top: 80, right: 162, bottom: 40, left: 75, },
						size: {	width: 800,	height: 1000, },
						lineWidth: 5,
						dotSize: 3,						
					},
				},
				desktop: {
					candidates: {
						margin: { top: 40, right: 85, bottom: 40, left: 43, },
						size: {	width: 800 , height: 800,},
						lineWidth: 1.5,
						dotSize: 4,
					},
					families: {
						margin: { top: 40, right: 120, bottom: 40, left: 45, },
						size: {	width: 800 , height: 800,},
						lineWidth: 1.5,
						dotSize: 4,
					},
					previous: {
						margin: { top: 40, right: 120, bottom: 40, left: 45, },
						size: {	width: 800 , height: 800,},
						lineWidth: 1.5,
						dotSize: 1.5,
					}	
				}
			},
			rwdHeatmapSettings: {
				mobile: {
					margin: { top: 140, right: 10, bottom: 40, left: 280, },
					size: {	width: 800 },
					rotateXLabelsOffset: 95,
				},
				desktop: {
					margin: { top: 112, right: 10, bottom: 40, left: 160, },
					size: {	width: 800 },
					rotateXLabelsOffset: 95,
				}, 
				largeScreen: {
					margin: { top: 60, right: 10, bottom: 40, left: 120, },
					size: {	width: 800 },
					rotateXLabelsOffset: 45,
				}, 
			},
			activeView : '',
			views: {
				default: 'round1',
				list: [
					{
						code: 'round1',
						inactive: false,
						wording: 'Premier tour',
					},
					{
						code: 'round2',
						inactive: false,
						wording: 'Deuxième tour',
					},
				]
			},
			activeViewRunoffs: '',
			viewsRunoffs: {
				default: '',
				list: [],
			},
			activeCandidatesId: [],
			activeCandidates2017Id: [],
			candidatesInUrl: [],
		}
	},
	created() {

		// Check display mode (single or all) in URL parameters
		let urlParams = new URLSearchParams(document.location.search)
		if (!!urlParams.get('mode')) this.mode = urlParams.get('mode')
		if (!!urlParams.get('candidates')) {
			let candidatesInUrl = urlParams.get('candidates').split('|')
			candidatesInUrl = candidatesInUrl.slice(0,6)
			candidatesInUrl.map(candidatesInUrl => {
				this.candidatesInUrl.push(normalize(candidatesInUrl, true))
			})
		}
		//if (this.isDev) this.mode = 'light'
		if (this.mode == 'light') {
			let $body = document.querySelector('body')
			$body.classList.add('--noborder')
			this.minCandidateScore = 10
		}

		// Set default view (= election round) as active view
		this.activeView = this.views.list.find(v => v.code == this.views.default)

		// Check screen size and set chart settings 
		if (this.mode == 'light') {
			this.rwdChartSettings.desktop.dotSize = 2
		}
		this.chartSettings = this.rwdChartSettings.desktop
		this.heatmapSettings = this.rwdHeatmapSettings.desktop

		// Set settings for mobile screen
		if (window.innerWidth <= this.breakpoints.mobile) this.mobile = true
		if (this.mobile) this.chartSettings = this.rwdChartSettings.mobile

		// Set settings for small screen
		if (window.innerWidth <= this.breakpoints.smallScreen) this.smallScreen = true
		if (this.smallScreen) this.heatmapSettings = this.rwdHeatmapSettings.mobile

		// Set settings for large screen
		if (window.innerWidth >= this.breakpoints.largeScreen) this.largeScreen = true
		if (this.largeScreen) this.heatmapSettings = this.rwdHeatmapSettings.largeScreen

		this.heatmapSettings['width'] = window.innerWidth


		// Get infographics data (candidates info, first round charts and run-offs charts)
		let urls = [
			this.urls.infos,
			this.urls.chartFirstRound.candidates,
			this.urls.chartFirstRound.families,
			this.urls.chartRunoffs,
			this.urls.chart2017,
		]
		if (this.isDev) {
			console.log('Getting data:')
			Array.from(urls).map(url => console.log(url))
		}
		Promise.all(urls.map(url =>
			fetch(url, {cache: 'no-store'}).then(resp => resp.json())
		))
		.then(jsons => {
			if (this.isDev) jsons.map(json => {
				console.log(json)
			})
			this.raw.infos.candidates = jsons[0].candidates
			this.raw.infos.candidates2017 = jsons[0].candidates2017
			this.raw.infos.events = jsons[0].events
			this.raw.chart = jsons[1]
			this.raw.chartFamilies = jsons[2]
			this.raw.chartRunoffs = jsons[3]
			this.raw.chartRunoffs.forEach(chartRunoff => {
				this.viewsRunoffs.list.push({
					code: chartRunoff.name,
					wording: chartRunoff.name.replace(' – ','/'),
					inactive: false,
				})
			})
			this.raw.chart2017 = jsons[4]

			// Set most frequent run-off scenario as active run-off view
			this.activeViewRunoffs = this.viewsRunoffs.list[0]
			this.finishInit()
		})
		.catch((err) => {
			console.log(err)
		})
	},
	computed: {
		chartDataCandidates: function() {
			let rawChart = this.raw.chart
			if (this.activeView.code == 'round2') rawChart = this.raw.chartRunoffs.find(c => c.name == this.activeViewRunoffs.code)
			let data = {
				y: 'Intentions de vote',
				lines: [],
				dots: [],
				areas: [],
				dates: rawChart.dates,
				comments: [],
			}
			this.candidatesActive.map(candidate => {
				
				let line = rawChart.lines.find(l => l.name == candidate.full_name)
				if (!!line) {
					line['label'] = candidate.last_name
					line['labelShort'] = candidate.short_name
					line['color'] = candidate.party_color
					data.lines.push(line)
				}
				let dots = rawChart.dots.find(d => d.name == candidate.full_name)
				if (!!dots) {
					dots.data.map(entry => {
						let date = new Date(entry.info.date)
						let html = '' + 
						'<div class="tt__score">' +
						'	' + toLocale(entry.y, 3) + '\xa0%' +
						'</div>' +
						'<div class="tt__candidate" style="color: ' + candidate.party_color + ' ">' +
						'	' + candidate.last_name + '</div>' +
						'</div>' + 
						'<div class="tt__details">' +
						'	' + (entry.info.hypothesis != 'Hypothèse sans nom' && !!entry.info.hypothesis ? entry.info.hypothesis + ', ' : '') +
						'	' + entry.info.organization + ', ' + date.toLocaleString('fr-FR', { day: 'numeric', month: 'long' }).replace(/^(\d+)\s(.+)/,'$1\xa0$2') +
						'</div>'
						let delay = parseInt(Math.random()*10)/10
						data.dots.push({
							label: candidate.last_name,
							color: candidate.party_color,
							html: html,
							x: entry.x,
							y: entry.y,
							id: entry.info.fullId,
							delay: delay,
						})
					})
				}
				let areas = rawChart.areas.filter(a => a.name == candidate.full_name)
				areas.map(area => {
					area['label'] = candidate.last_name
					area['color'] = candidate.party_color
					data.areas.push(area)
				})
				
			})
			data.lines.sort((a,b) => {
				return b.data[b.data.length - 1].y - a.data[a.data.length - 1].y
			})

			return data
		},
		chartDataFamilies: function(){
			let rawChart = this.raw.chartFamilies
			let data = {
				y: 'Somme des intentions de vote par famille politique',
				lines: [],
				dots: [],
				areas: [],
				dates: rawChart.dates,
				comments: this.raw.infos.events,
			}
			this.families.map(family => {
				
				// Prepare political family line
				let line = rawChart.lines.find(l => l.name == family.name)
				if (!!line) {
					line['label'] = family.name,
					line['color'] = family.color,
					data.lines.push(line)
				}

				// Prepare political family area (= MOE)
				let area = rawChart.areas.find(a => a.name == family.name)
				if (!!area) {
					area['label'] = family.name
					area['color'] = family.color
					data.areas.push(area)
				}

			})

			return data
		},
		chartData2017: function() {
			let rawChart = this.raw.chart2017
			let data = {
				y: 'Intentions de vote avant la présidentielle 2017',
				lines: [],
				dots: [],
				areas: [],
				dates: rawChart.dates,
				comments: [],
			}
			
			this.candidatesActive2017.forEach(candidate => {
				
				// Prepare political family line
				let line = rawChart.lines.find(l => l.name == candidate.name)
				if (!!line) {
					line['label'] = candidate.last_name,
					line['color'] = candidate.party_color,
					data.lines.push(line)
				}

				// Prepare political family area (= MOE)
				let area = rawChart.areas.find(a => a.name == candidate.name)
				if (!!area) {
					area['label'] = candidate.last_name
					area['color'] = candidate.party_color
					data.areas.push(area)
				}

				// Prepare poll dots
				let dots = rawChart.dots.find(d => d.name == candidate.name)
				if (!!dots) {
					dots.data.map(entry => {
						let date = new Date(entry.info.date)
						let html = '' + 
						'<div class="tt__score">' +
						'	' + toLocale(entry.y, 3) + '\xa0%' +
						'</div>' +
						'<div class="tt__candidate" style="color: ' + candidate.party_color + ' ">' +
						'	' + candidate.name + '</div>' +
						'</div>' + 
						'<div class="tt__details">' +
						'	' + (entry.info.hypothesis != 'Hypothèse inconnue' && !!entry.info.hypothesis ? entry.info.hypothesis + ', ' : '') +
						'	' + entry.info.organization + ', ' + date.toLocaleString('fr-FR', { day: 'numeric', month: 'long' }).replace(/^(\d+)\s(.+)/,'$1\xa0$2') +
						'</div>'
						let delay = parseInt(Math.random()*10)/10
						data.dots.push({
							label: candidate.last_name,
							color: candidate.party_color,
							html: html,
							x: entry.x,
							y: entry.y,
							id: entry.info.fullId,
							delay: delay,
						})
					})
				}

			})
			
			return data
		},
		images: function() {

			return this.candidates.reduce((agg, candidate) => {
				if (!candidate.s3image) return agg
				return agg.concat({
					name: candidate.last_name,
					author: candidate.s3image.copyright,
				})
			}, [])
		},
		candidates: function() {

			let candidates = clone(this.raw.infos.candidates.filter(c => c.keep == 'oui'))
			let chart = this.raw.chart
			if (this.activeView.code == 'round2') {
				chart = this.raw.chartRunoffs.find(c => c.name == this.activeViewRunoffs.code)
				candidates = candidates.filter(c => !!chart.dots.find(d => d.name == c.full_name))
			}

			candidates.map(candidate => {

				// Prepare candidate misc infos
				candidate['last'] = 0
				candidate['lastTxt'] = 'nc'
				candidate.party_pos = parseInt(candidate.party_pos)

				// Create candidate ID
				candidate['id'] = Math.abs(hashString(this.activeView.code + candidate.last_name))
				if (this.activeView.code == 'round2') candidate.id = Math.abs(hashString(this.activeView.code + '-' + this.activeViewRunoffs.code + '-' + candidate.last_name))

				// Get candidate last available scores
				let thisArea = chart.areas.find(a => a.name == candidate.full_name)
				let thisLine = chart.lines.find(l => l.name == candidate.full_name)
				if (!!thisLine && !!thisLine.data.length) {
					candidate.last = thisLine.data[thisLine.data.length - 1].y
				}
				if (!!thisArea && !!thisArea.data.length)	{
					candidate.lastTxt = '' +
						toLocale(thisArea.data[thisArea.data.length - 1].min, 2) + '–' +
						toLocale(thisArea.data[thisArea.data.length - 1].max, 2) + '\xa0%'
				}

				// Prepare first round polls
				candidate['polls'] = []
				let dots = chart.dots.find(d => d.name == candidate.full_name)
				if (!!dots) candidate['polls'] = this.convertDotsToPolls(dots)
				candidate.polls.sort((a,b) => b.date - a.date)

			})
			candidates.sort((a,b) => {
				return b.last - a.last
			})

			if (this.activeView.code == 'round2') return candidates
			if (this.mode == 'light' && !!this.candidatesInUrl.length) return candidates.filter(c => this.candidatesInUrl.includes(normalize(c.last_name, true)))
			return candidates.filter(c => c.last >= this.minCandidateScore)
		},
		candidatesActive: function() {
			return this.candidates.reduce((acc, candidate) => {
				if (this.activeCandidatesId.includes(candidate.id)) return acc.concat(candidate)
				return acc
			}, [])
		},
		candidates2017: function() {
			let candidates = []
			this.raw.infos.candidates2017.forEach(candidate => {
				let id = Math.abs(hashString('2017' + candidate.name))
				let polls = this.raw.chart2017.dots.find(d => d.name == candidate.name)
				candidates.push({...candidate, ...{'id': id, 'last': polls.data[0].y}})
			})

			return candidates
		},
		candidatesActive2017: function() {
			return this.candidates2017.reduce((acc, candidate) => {
				if (this.activeCandidates2017Id.includes(candidate.id)) return acc.concat(candidate)
				return acc
			}, [])
		},
		families: function() {
			let families = []
			this.raw.infos.candidates.filter(c => c.keep == 'oui').forEach(candidate => {
				let thisFamily = families.find(f => f.name == candidate.party_family)
				if (!thisFamily) {
					thisFamily = {
						name: candidate.party_family,
						color: candidate.party_family_color,
						candidates: [],
					}
					families.push(thisFamily)
				}
				thisFamily.candidates.push({
					name: candidate.last_name,
					party: {
						acronym: candidate.party_acronym,
						name: candidate.party_name,
					}
				})
			})
			families.forEach(family => {
				family.candidates.sort((a,b) => a.name.localeCompare(b.name))
			})
			families.sort((a,b) => b.candidates.length - a.candidates.length)

			return families 
		},
		polls: function() {
			return this.candidates.reduce((acc, candidate) => {

				let polls = candidate.polls
				polls.map(poll => {
					let thisPoll = acc.find(p => p.hypoId == poll.info.hypoId)
					if (!thisPoll) {
						thisPoll = clone(poll.info)
						delete thisPoll.fullId
						thisPoll['candidates'] = []
						acc.push(thisPoll)
					}
					thisPoll.candidates.push({
						name: candidate.full_name_clean,
						id: candidate.id,
						score: poll.score,
					}) 
				})
				return acc
			}, []).sort((a,b) => a.date.localeCompare(b.date))
		},
		heatmapData: function() {
			let xLabels = []
			let currentPoll = ''
			let hypNb = 1
			this.polls.forEach(poll => {
				if (poll.pollId != currentPoll) {
					currentPoll = poll.pollId
					hypNb = 1
				} else {
					hypNb += 1
				}
				let row1 = !!orgShots[poll.organization] ? orgShots[poll.organization] : poll.organization
				let date = new Date(poll.date)
				row1 += ' ' + date.toLocaleString('fr-FR', {
					day: 'numeric',
					month: 'numeric'
				}).replace(/(^|\/)0+/g, '$1')
				row1 = '<a target="_blank" href="' + poll.link + '">' + row1 + '</a>'
				let row2 = 'Hyp. ' + hypNb
				xLabels.push([row1, row2])
			})

			let lines = []
			let labels = []
			let flags = []
			let candidates = clone(this.candidates)
			candidates.sort((a,b) => a.party_pos - b.party_pos).forEach(candidate => {
				labels.push(candidate.last_name)
				flags.push({
					color: candidate.party_color,
					text: candidate.party_acronym,
				})
				let line = []
				this.polls.forEach(poll => {
					let thisCandidate = poll.candidates.find(c => c.id == candidate.id)
					!!thisCandidate ? line.push(thisCandidate.score) : line.push(0)
				})
				lines.push(line)
			})

			return { lines: lines, labels: labels, xLabels: xLabels, flags: flags  }
		},
		minCandidateScoreTxt: function() {
			return toLocale(this.minCandidateScore, 2)
		}
	},
	methods: {
		convertDotsToPolls: function(dots) {
			let polls = []
			dots.data.map(entry => {
				let date = new Date(entry.info.date)
				let dateTxt = date.toLocaleString('fr-FR', {
					day: 'numeric',
					month: 'long',
					year: 'numeric',
				})
				polls.push({
					score: entry.y,
					scoreTxt: toLocale(entry.y, 2),
					info: entry.info,
					date: date,
					dateTxt: dateTxt,
				})
			})

			return polls
		},
		setMinHeight: function(chartMinHeight) {
			if (!!chartMinHeight) {
				this.minHeight = parseInt(document.body.scrollTop + this.$el.getBoundingClientRect().top + chartMinHeight)
			} else {
				this.minHeight = 0
			}
		},
		toggleCandidate: function(id, year=2022) {
			if (year == 2022) {
				if (this.activeView.code =='round1') {				
					if (this.activeCandidatesId.includes(id)) {
						this.activeCandidatesId = this.activeCandidatesId.filter(c => c != id)
					} else {
						this.activeCandidatesId.push(id)
					}
				}
			}
			if (year == 2017) {
				if (this.activeCandidates2017Id.includes(id)) {
					this.activeCandidates2017Id = this.activeCandidates2017Id.filter(c => c != id)
				} else {
					console.log(year)
					this.activeCandidates2017Id.push(id)
				}

			}
		},
		finishInit: function() {
			this.ready = true
			if (inIframe() && this.mobile && this.mode == 'full') {
				this.$nextTick(function() {
					let $target = parent.document.querySelector('.dz-js-dataviz').parentNode
					$target.appendChild(this.$refs.toggles.$el)
				})
			}
			if (this.mode == 'full') hideLoader()

		}
	},
	watch: {
		candidates: function() {
			this.candidates.forEach((candidate, c) => {
				if (this.activeView.code == 'round2' || this.mode == 'light' || c+1 <= this.defaultCandidatesNb) this.activeCandidatesId.push(candidate.id)
			})
		},
		candidates2017: function() {
			this.candidates2017.forEach((candidate) => {
				if (candidate.running == 'oui') this.activeCandidates2017Id.push(candidate.id)
			})
		}
	}
}